import React, { useCallback } from 'react'

import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { timeInHuman } from 'util/date'

export default function ShopifyOrderRow({
  doNavigatableSetState,
  moneyFormat,
  order,
  order: {
    id,
    created_at: createdAt,
    order_number: orderNumber,
    total_price: totalPrice,
  },
}) {
  const onClick = useCallback(
    () => {
      doNavigatableSetState({ id, type: 'order' })
    },
    [doNavigatableSetState, id]
  )
  const totalWithCurrency = (moneyFormat || '{{amount}}').replace(
    '{{amount}}',
    totalPrice
  )
  if (order)
    return (
      <NavigatableIntegrationWidgetCard.ListItem
        onClick={onClick}
        subTitle={`${timeInHuman(createdAt)} · ${totalWithCurrency}`}
        title={`Order: #${orderNumber}`}
      />
    )
  return null
}
